export const getModeClassicTopNavBarStyle = (baseTheme, palette) => {
    return {
        root: {
            background: '#ffffff',
            color: palette.text.primary,
        },
        toolBar: {
            borderBottom: '1px solid #E6E7E9',
        },
        profileMenuRole: {
            color: palette.secondary.light,
        },
    };
};
